import { render } from "./ImportDocument.vue?vue&type=template&id=1e85cdfc"
import script from "./ImportDocument.vue?vue&type=script&lang=js"
export * from "./ImportDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__